import React, { useState } from "react";
import { Modal, Button, Dropdown, Form, Icon } from "semantic-ui-react";

const RestoreModal = ({
  open,
  onClose,
  handleSubmit,
  unitDetails,
  tabOptions,
}) => {
  const [selectedTab, setSelectedTab] = useState("");

  const handleRestore = async () => {
    if (!selectedTab) return;
    try {
      unitDetails.status = selectedTab;
      await handleSubmit(unitDetails);
      onClose();
    } catch (error) {
    } finally {
    }
  };

  const onChangeCriticalType = (e, { value }) => {
    setSelectedTab(value);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="tiny"
      dimmer={"inverted"}
      //   closeOnDimmerClick={false}
    >
      <>
        {/* Header */}
        <div className="critical-list-modal-header">
          <div className="modal-header-title">Restore Critical Unit</div>

          <div className="modal-header-close" onClick={onClose}>
            <Icon name="times circle outline" />
          </div>
        </div>

        {/* Content */}
        <div className="critical-list-modal-content">
          <div className="delete-reason-message">
            Are you sure you want to restore unit #{" "}
            {unitDetails?.unit_number || ""} at "
            {unitDetails?.building_address || ""}".
          </div>

          <Form>
            <Form.Field required>
              <label>Select Restoration Location</label>

              <Dropdown
                id="delete-reason-dropdown"
                placeholder="Select tab"
                selection
                options={tabOptions}
                value={selectedTab === "" ? null : selectedTab}
                onChange={onChangeCriticalType}
                selectOnBlur={false}
              />
            </Form.Field>
          </Form>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <Button basic color="grey" onClick={onClose}>
            Cancel
          </Button>

          <Button color="green" onClick={handleRestore} disabled={!selectedTab}>
            Confirm
          </Button>
        </div>
      </>
    </Modal>
  );
};

export default RestoreModal;
